import React, { ReactElement } from 'react';

import Box from 'atomic/box';
import Link from 'atomic/link';
import Icon from 'atomic/icon';
import Chips from 'atomic/form/chips';
import { FilterActiveProps } from 'modules/shared/components/filters/components/filters-active/filter-active.props';
import { useActiveFilters } from 'modules/shared/components/filters/hooks/use-active-filters';

import './filter-active-desktop.scss';

const FilterActiveDesktop: React.FC<FilterActiveProps> = ({ filtersIds, filters, getUrl }): ReactElement | null => {
    const activeFilters = useActiveFilters(filtersIds, filters);

    if (activeFilters.length === 0) {
        return null;
    }

    return (
        <Box className="filter-active">
            <div className="filter-active__header">
                <div className="header__title">Aktywne filtry</div>
                <Link
                    className="clear-filters"
                    href={getUrl({ filters: [], page: 1, query: {}, price: { min: 0, max: 0 } })}
                    color="flat"
                    type="link"
                    size="lg"
                >
                    <Icon name="x" size={16} color="primary" />Wyczyść filtry
                </Link>
            </div>
            <div className="filter-active__content">
                {
                    activeFilters.map((filter) => {
                        return (
                            <div className="item" key={filter.groupName}>
                                <span className="group-name">{filter.groupName}: </span>
                                {
                                    filter.items.map((item) => (
                                        <a key={item.id} href={getUrl({ subFilters: [item.id], page: 1, query: {} })}>
                                            <Chips>
                                                <span>{item.name}</span>
                                            </Chips>
                                        </a>
                                    ))
                                }
                            </div>
                        );
                    })
                }
            </div>
        </Box>
    );
};

export default FilterActiveDesktop;
